export const reportConstants = {
	GETALL_REQUEST: 'REPORTS_GETALL_REQUEST',

	GET_EXECUTEDREPORTS_SUCCESS: 'REPORTS_GET_EXECUTEDREPORTS_SUCCESS',

	GET_EXECUTEDREPORTS_URI_SUCCESS: 'REPORTS_GET_EXECUTEDREPORTS_URI_SUCCESS',

	GET_CONFIGUREDREPORTS_SUCCESS: 'REPORTS_GET_CONFIGUREDREPORTS_SUCCESS',

	SET_EXEC_REPORTS_PARAMS: 'REPORTS_SET_EXEC_REPORTS_PARAMS',

	GETALL_FAILURE: 'REPORTS_GETALL_FAILURE',

	RESET_REPORTS_PIPELINES: 'RESET_REPORTS_PIPELINES',
	UPDATE_REPORTS_PIPELINES: 'UPDATE_REPORTS_PIPELINES',

	GET_ALL_START_REPORTS_DETAILS_SUCCESS: 'GET_ALL_START_REPORTS_DETAILS_SUCCESS',
	EXPAND_ROW: 'REPORTS_EXPAND_ROW',
	CLEAR_REPORTS: 'CLEAR_REPORTS',
	SET_ACTIVE_ROW: 'REPORTS_SET_ACTIVE_ROW',
	TOGGLE_EXEC_REPORTS_SELECT_ALL: 'TOGGLE_EXEC_REPORTS_SELECT_ALL',
	TOGGLE_EXEC_REPORTS_SELECTION: 'TOGGLE_EXEC_REPORTS_SELECTION',

	TOGGLE_REPORTS_ACTIVE_TAB: 'REPORTS_TOGGLE_REPORTS_ACTIVE_TAB',

	GET_CONFIGUREDREPORTS_REQUEST: 'REPORTS_GET_CONFIGUREDREPORTS_REQUEST',
	GET_CONFIGUREDREPORTS_FAILURE: 'REPORTS_GET_CONFIGUREDREPORTS_FAILURE',

	TOGGLE_MODAL_ADD_REPORT_WIZARD: 'REPORTS_TOGGLE_MODAL_ADD_REPORT_WIZARD',
	TOGGLE_WIZARD_SELECTED_REPORT_ID: 'REPORTS_TOGGLE_WIZARD_SELECTED_REPORT_ID',
	TOGGLE_WIZARD_SELECTED_REPORT: 'REPORTS_TOGGLE_WIZARD_SELECTED_REPORT',

	SET_SELECTED_REPORT_EDIT: 'REPORTS_SET_SELECTED_REPORT_EDIT',
	SET_SELECTED_REPORT_EDIT_IS_ACTIVE: 'REPORTS_SET_SELECTED_REPORT_EDIT_IS_ACTIVE',
	SET_SELECTED_REPORT_EDIT_IS_INTERNAL_USE: 'REPORTS_SET_SELECTED_REPORT_EDIT_IS_INTERNAL_USE',

	SET_DEFAULT_REPORT_PAGE: 'REPORTS_SET_DEFAULT_REPORT_PAGE',
	
	SET_HANDLE_GRID_RELOAD_CALLBACK: 'REPORTS_SET_HANDLE_GRID_RELOAD_CALLBACK',
	
	SET_SELECTED_NEW_REPORT_CUSTOMER: 'REPORTS_SET_SELECTED_NEW_REPORT_CUSTOMER',
};
